module.exports = __webpack_public_path__ + "ab6fb7e3af56f69fab91f860748cfc6d.png";